export default {
  "hierarchy": {
    "small": [
      "dropdown-small"
    ],
    "test": [
      "dropdown-test"
    ]
  },
  "props": {
    "default": {
      "selectIcon": "fa fa-chevron-down"
    },
    "small": {
      "selectIcon": "fa fa-chevron-down",
      "icons": null
    },
    "test": {
      "selectIcon": "fa fa-chevron-down"
    }
  }
}